<template>
  <div>
    <case-seo ref="seo"></case-seo>
    <banner-set ref="banner"></banner-set>
    <industry-point ref="industry"></industry-point>
    <customer-scene ref="scene"></customer-scene>
    <div class="title_btn">
      <el-button type="primary" @click="submit">确定</el-button>
      <el-button type="primary" plain @click="$router.go(-1)">取消</el-button>
    </div>
  </div>
</template>
<script>
import { addIndustrySolutions, editIndustrySolutions, industrySolutionsDetail } from "@/api/solution";
import baseURL from "../../configs/baseUrl";
import utils from "@/jslibs/utils";
import { imgDomain } from "../../configs/env";
import CaseSeo from "./components/caseSeo";
import BannerSet from "./components/bannerSet";
import IndustryPoint from "./components/industryPoint";
import CustomerScene from "./components/customerScene";
export default {
  components: {
    CaseSeo,
    BannerSet,
    IndustryPoint,
    CustomerScene,
  },
  data() {
    return {
      imgDomain,
      headers: {
        "X-Access-Token": utils.getCookie("X-Access-Token") || "",
      },
      baseURL,
      loading: false,
      id: "",
      scenarios_item: [],
    };
  },

  created() {
    const id = this.$route.query.id;
    this.id = id;
    if (id) {
      this.industrySolutionsDetail(id);
    }
  },

  methods: {
    async industrySolutionsDetail(id) {
      const res = await industrySolutionsDetail(id);
      const solutionDetail = res;
      const seoInfo = {
        sort: solutionDetail.sort,
        name: solutionDetail.name,
        seo_t: solutionDetail.seo_t,
        seo_d: solutionDetail.seo_d,
        seo_k: solutionDetail.seo_k,
      };
      const bannerInfo = {
        bannerImg: solutionDetail.banner_img.split(),
        banner_img: solutionDetail.banner_img,
        iconImg: solutionDetail.banner_icon.split(),
        banner_icon: solutionDetail.banner_icon,
        h5_banner_img: solutionDetail.h5_banner_img,
        h5Img: solutionDetail.h5_banner_img.split(),
        h5Icon: solutionDetail.h5_banner_icon.split(),
        h5_banner_icon: solutionDetail.h5_banner_icon,
        banner_alt: solutionDetail.banner_alt,
        is_jump: String(solutionDetail.is_jump),
        jump_url: solutionDetail.jump_url,
      };

      const industryInfo = {
        industry_background_img: solutionDetail.industry_background_img,
        industryBgImg: solutionDetail.industry_background_img.split(),
        industry_background_img_alt: solutionDetail.industry_background_img_alt,
        frameworkImg: solutionDetail.framework_img.split(),
        framework_img: solutionDetail.framework_img,
        framework_title: solutionDetail.framework_title,
        framework_img_alt: solutionDetail.framework_img_alt,
      };
      const scenceList = [...solutionDetail.scenarios_item];

      solutionDetail.pain_points_item.forEach((item, index) => {
        item.img_list = item.image.split();
      });
      solutionDetail.solution_item.forEach((item, index) => {
        item.img_list = item.image.split();
      });

      this.$refs["seo"].seoInfo = seoInfo;
      this.$refs["banner"].bannerInfo = bannerInfo;

      this.$refs["industry"].industryInfo = industryInfo;
      this.$refs["industry"].pain_points_item = [...solutionDetail.pain_points_item];
      this.$refs["industry"].solution_item = [...solutionDetail.solution_item];
      this.$refs["industry"].num = solutionDetail.pain_points_item.length;
      this.$refs["industry"].solu_num = solutionDetail.solution_item.length;
      this.$refs["scene"].scenceList = [...solutionDetail.scenarios_item];
    },

    submit() {
      const seoVerify = this.$refs["seo"].verifyInput();
      if (seoVerify) {
        const bannerVerify = this.$refs["banner"].verifyInput();
        if (bannerVerify) {
          const industryVerify = this.$refs["industry"].verifyInput();
          if (industryVerify) {
            const sceneVerify = this.$refs["scene"].verifyInput();
            if (sceneVerify) {
              const seoInfo = this.$refs["seo"].seoInfo;
              const bannerInfo = this.$refs["banner"].bannerInfo;
              const industryInfo = this.$refs["industry"].industryInfo;
              const sceneInfo = this.$refs["scene"].sceneInfo;

              const solutionInfo = Object.assign({}, seoInfo, bannerInfo, industryInfo, sceneInfo);
              this.confirmSubmit(solutionInfo);
            }
          }
        }
      }
    },

    async confirmSubmit(solutionInfo) {
      if (this.id) {
        const res = await editIndustrySolutions(this.id, solutionInfo);
        if (res == true) {
          this.$notify.success({ title: "案例解决方案成功" });
          this.$router.back();
        } else {
          this.$notify.success({ title: "操作失败" });
        }
      } else {
        const res = await addIndustrySolutions(solutionInfo);
        if (res == true) {
          this.$notify.success({ title: "新增解决方案成功" });
          this.$router.back();
        } else {
          this.$notify.success({ title: "操作失败" });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.form-item {
  display: flex;
  align-items: center;
  margin: 20px;
  .icon_type {
    margin-right: 20px;
  }
}
.label {
  display: inline-block;
  width: 180px;
  flex-shrink: 0;
}
.title_btn {
  margin-top: 50px;
}
</style>
